<template>
  <div>
    <page-table :data-api="this.api.whiteList" :viewable="false" keyField="id">
      <el-table-column prop="id" label="编号" width="80">
      </el-table-column>
      <el-table-column prop="mac" label="mac地址">
      </el-table-column>
      <el-table-column prop="loginCount" label="登录次数">
      </el-table-column>
      <el-table-column prop="vip" label="是否VIP">
        <template slot-scope="scope">
          {{scope.row.vip}}
        </template>
      </el-table-column>
      <el-table-column prop="vipType" label="VIP类型">
        <template slot-scope="scope">
          {{scope.row.vipType==1?"试播VIP":scope.row.vipType==2?"付费VIP":"非VIP"}}
        </template>
      </el-table-column>
      <el-table-column prop="expireDate" label="到期时间">
      </el-table-column>
      <el-table-column prop="enabled" label="启用">
        <template slot-scope="scope">
          {{scope.row.enabled}}
        </template>
      </el-table-column>
      <el-table-column prop="createDate" label="添加时间">
      </el-table-column>
    </page-table>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  created: function () {
  },
  methods: {
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// List.vue?69d96996